/* eslint-disable no-unused-vars */
export type Source = {
  label: string;
  type?: string;
  url: string;
};
export type SpeedRate = 1 | 0.25 | 0.5 | 0.75 | 1.25 | 1.5 | 1.75 | 2;
export type PlayerSettings = {
  speedRate: SpeedRate;
  pipSupported: boolean;
  pip: boolean; //playing picture in picture
  volume: number;
  lastVolume: number;
  isMuted: boolean;
  quality: string;
  fullScreen: boolean;
  pipEnable: boolean; // playing picture in picture button
  fullScreenEnable: boolean;
  withSubtitle: boolean;
  subtitleOn: boolean;
};
export type SpeedRateItem = {
  label: string;
  id: SpeedRate;
  show: boolean;
};

export enum SEEK_STATUS {
  BACKWARD = "BACKWARD",
  FORWARD = "FORWARD",
}
